"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parser = require('regex-parser');
/**
 *
 * @param {string} input
 * @returns {RegExp}
 */
function regexParser(input) {
    return parser(input);
}
exports.regexParser = regexParser;
